export default adr => {
    if (adr) {
        let { streetName, streetNumber, streetNumberBte, postalCode, city, countryCode } = adr;
        return (`${streetName} ${streetNumber} ${streetNumberBte ? `Bte ${streetNumberBte}` : ""}, ${postalCode} ${city}, ${countryCode}`);
    }
    else
        return null;
}